import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.href

    try {
      await navigator.clipboard.writeText(text)

      const originalText = this.buttonTarget.textContent
      this.buttonTarget.textContent = "已複製！"

      setTimeout(() => {
        this.buttonTarget.textContent = originalText
      }, 1000)
    } catch (err) {
      console.error('複製失敗:', err)
    }
  }
}
